import { NO_CHARM_ID } from '../helpers/constants';

/**
 * Returns the effective charm id based on the given parameters
 * @param charmId charm id of the calendar event
 * @param parentCharmId charm id of the calendar to which the event belongs
 * @param fallbackToNoCharm Whether or not to retun fallback charm if no charm found
 */
export const getEffectiveCharmId = (
    charmId: number,
    parentCharmId?: number,
    fallbackToNoCharm?: boolean
): number => charmId || parentCharmId || (fallbackToNoCharm ? NO_CHARM_ID : undefined);
